import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useSeoPageSubmit from "hooks/useSeoPageSubmit";
import InputArea from "components/form/InputArea";
import QuillEditor from "components/form/QuillEditor";
import SelectSingleCityOnly from "components/form/SelectSingleCityOnly";
import SelectSingleCityToOnly from "components/form/SelectSingleToCityOnly";
import React from "react";
import Scrollbars from "react-custom-scrollbars-2";
import SelectTripTypeThree from "components/form/SelectTripTypeThree";

const SeoPageDrawer = ({ id, isViewMode }) => {
  const {
    content,
    setContent,
    register,
    handleSubmit,
    selectedfromCity,
    selectedtoCity,
    setSelectedfromCityName,
    setSelectedtoCityName,
    setSelectedTripType,
    selectedTripType,
    onSubmit,
    setSelectedfromCity,
    setSelectedtoCity,
    trigger,
    errors,
    loading,
  } = useSeoPageSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {isViewMode ? (
          <>
            <Title title={"View Seo Page"} />
          </>
        ) : (
          <>
            {id ? (
              <Title title={"Edit Seo Page"} description={""} />
            ) : (
              <Title title={"Add Seo Page"} description={""} />
            )}
          </>
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-12 gap-x-6 gap-y-4">
              <div
                className={`${
                  selectedTripType === "Outstation"
                    ? "col-span-4"
                    : "col-span-6"
                }`}
              >
                <LabelArea required label="Type of Trip" />
                <SelectTripTypeThree
                  readOnly={isViewMode}
                  required={true}
                  register={register}
                  defaultValue={selectedTripType}
                  onChange={(e) => setSelectedTripType(e.target.value)}
                  name="type_of_trip"
                  label="Trip Type"
                />
                <Error errorName={errors.type_of_trip} />
              </div>

              <div
                className={`${
                  selectedTripType === "Outstation"
                    ? "col-span-4"
                    : "col-span-6"
                }`}
              >
                <LabelArea required label="From City" />
                <SelectSingleCityOnly
                  register={register}
                  label="From City"
                  name="fromcity"
                  selectedCity={selectedfromCity}
                  handleCityChange={setSelectedfromCity}
                  handleCityChangeName={setSelectedfromCityName} // Optional
                />
                <Error errorName={errors.fromcity} />
              </div>

              {selectedTripType === "Outstation" && (
                <div className="col-span-4">
                  <LabelArea required label="To City" />
                  <SelectSingleCityToOnly
                    register={register}
                    label="To City"
                    name="tocity"
                    selectedCity={selectedtoCity}
                    handleCityChange={setSelectedtoCity}
                    handleCityChangeName={setSelectedtoCityName} // Optional
                    required
                  />
                  <Error errorName={errors.tocity} />
                </div>
              )}

              <div className="col-span-12">
                <LabelArea required label="URL" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  label="URL"
                  name="url"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.url} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Description" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  maxLength={160}
                  label="Description"
                  name="description"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.description} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Keywords" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  label="Keywords"
                  name="keywords"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.keywords} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Title" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  maxLength={70}
                  label="Title"
                  name="title"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.title} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="H1 Tag" />
                <InputArea
                  trigger={trigger}
                  register={register}
                  readOnly={isViewMode}
                  label="H1 Tag"
                  name="heading"
                  type="text"
                  placeholder=""
                />
                <Error errorName={errors.heading} />
              </div>

              <div className="col-span-12">
                <LabelArea required label="Content to Display" />
                <QuillEditor
                  required={true}
                  value={content}
                  readOnly={isViewMode}
                  onChangeFunction={(newContent) => setContent(newContent)}
                  register={register}
                  label="Content"
                  name="content"
                />

                <Error errorName={errors.content} />
              </div>
            </div>
          </div>

          {!isViewMode ? (
            <DrawerButton
              isSubmitting={loading}
              id={id}
              title={id ? "Update" : "Submit"}
            />
          ) : null}
        </form>
      </Scrollbars>
    </>
  );
};

export default SeoPageDrawer;
